import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { Payable } from '../../../../../models/entities/payable';

@Component({
    selector: 'app-payable-status-badge',
    templateUrl: './payable-status-badge.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatChipsModule,
        MatTooltipModule,
    ],
})
export class PayableStatusBadgeComponent
{
    @Input() payable: Payable;
    @Output() statusClicked: EventEmitter<any> = new EventEmitter();

    get status(): string {
        if (this.payable.currentFulfillment?.status) {
            return this.payable.currentFulfillment.status;
        } else {
            return this.payable.status;
        }
    }

    get hasError(): boolean {
        // Trust the backend's hasError flag from the HandlesFulfillmentErrors trait
        // which checks for uncleared errors in the payable_fulfillment_errors table
        if (this.payable.currentFulfillment?.hasError) {
            return true;
        }

        // Fallback to status-based error detection for states without fulfillments
        return this.isErrorStatus || !!this.errorMessage;
    }

    get errorMessage(): string {
        if (this.payable.currentFulfillment?.errorMessage) {
            return this.payable.currentFulfillment.errorMessage;
        }
        return '';
    }

    get isErrorStatus(): boolean {
        return ['Approval Denied', 'Declined', 'Cancelled', 'Failed'].includes(this.status);
    }

    get statusClass(): string {
        // Error states take priority
        if (this.isErrorStatus || this.hasError) {
            return 'error';
        }

        // Success states
        if (['Processed', 'Marked As Paid', 'Check Printed'].includes(this.status)) {
            return 'success';
        }

        // Sent/Processing states
        if (['Sent', 'Processing'].includes(this.status)) {
            return 'sent';
        }

        // Scheduled state
        if (this.status === 'Scheduled') {
            return 'scheduled';
        }

        // Draft states (default)
        if (['Draft', 'Pending Approval', 'Approved'].includes(this.status)) {
            return 'draft';
        }

        // Fallback to draft for any unknown status
        return 'draft';
    }
}
